import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import { spin } from 'shiftNotes/styles/shared.style';

export const Card = styled.div`
  align-items: center;
  background-color: ${colours.shade[0]};
  border-radius: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 30px 20px;
  width: 100%;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;
`;

export const Icon = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
  transform: rotate(180deg);

  svg {
    animation: ${spin} 2.5s linear infinite;
    height: 18px;
    stroke: ${colours.neutral[500]};
    width: 18px;
  }
`;

export const Label = styled.span`
  color: ${colours.neutral[500]};
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 650;
  line-height: 16px;
  white-space: nowrap;
`;
